import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsOptional, IsString, Length } from 'class-validator';

export class CreateComprobantePagoRecibidoDto {
  @ApiPropertyOptional({ example: 'Pago por transferencia bancaria' })
  @IsOptional()
  @IsString()
  @Length(3, 250, {
    message: 'Observación debe tener entre 3 y 250 caracteres',
  })
  observacion?: string;

  @ApiPropertyOptional({ example: '50000', description: 'Monto del pago' })
  @IsOptional()
  @IsString()
  monto?: string;
}
